<template>
  <div>
    <div class="">
      <h3 class="mt-3 text-center title">
        {{ `${financeiroTotal ? 'Meu Financeiro' : 'Meus Créditos'}` }}
      </h3>
      <drop-down class="btn-group">
        <template slot="title">
          <button type="button" class="btn btn-primary">
            Status: {{ namePasso }}
          </button>
          <button
            type="button"
            class="btn btn-primary dropdown-toggle dropdown-toggle-split"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="sr-only">Selecione</span>
          </button>
        </template>
        <a
          v-for="item in status"
          :key="item.id"
          class="dropdown-item text-dark"
          href="javascript:void(0)"
          @click="selecionaStatus(item)"
          >{{ item.status }}</a
        >
      </drop-down>
      <div v-if="transacoesFiltrados().length == 0" class="alert alert-danger">
        Nenhuma Transação Encontrada
      </div>
      <card
        noFooterLine
        v-for="item in transacoesFiltrados()"
        :key="item.id"
        class="card-nav-tabs text-center card-item"
        header-classes="card-header-warning"
      >
        <h4 class="card-title">Cód:{{ item.idRegistroFinanceiro }}</h4>
        <ul class="list-group list-group-horizontal-sm">
          <li class="list-group-item col-md-4 text-center">
            <strong>Forma de Pagamento:</strong>
            <div>{{ item.formaPagamento }}</div>
          </li>
          <li class="list-group-item col-md-4 text-center">
            <strong>Horário Processamento:</strong>
            <div>{{ formataDataUTC(item.dataProcessamento) }}</div>
          </li>
          <li class="list-group-item col-md-4 text-center">
            <strong>Descrição:</strong>
            <div>{{ item.descricao }}</div>
          </li>
        </ul>
        <ul class="list-group list-group-horizontal-sm">
          <li v-if="item.valor" class="list-group-item col-md-6 text-center">
            <strong>Valor:</strong>
            <div>
              <span type="success">{{ item.valor | currency }}</span>
            </div>
          </li>
          <li class="list-group-item col-md-6 text-center">
            <strong>Status:</strong>
            <div>
              <badge type="primary" :class="`mr-3 corStatus${item.idStatus}`"
                >{{ item.nomeStatus }}
              </badge>

              <n-button
                @click="buscaStatus(item)"
                v-if="item.idStatus == 3"
                class="btn-degrade"
              >
                <i class="now-ui-icons arrows-1_refresh-69 spin"></i>
              </n-button>
            </div>
          </li>
        </ul>
        <ul
          v-if="!item.dataPagamento && item.nomeStatus != 'Cancelado'"
          class="list-group list-group-horizontal-sm"
        >
          <li
            v-if="item.pixQrCode"
            class="list-group-item col-md-12 text-center"
          >
            <strong>Qr Code:</strong>
            <div>
              <VueQr :text="item.pixQrCode" />
            </div>
            <div class="input-group my-5">
              <input
                name="qr code"
                v-model="item.pixQrCode"
                class="form-control"
              />
              <div class="input-group-append">
                <button
                  @click="copiarQR(item.pixQrCode)"
                  class="btn btn-primario-formulario "
                  type="button"
                  id="button-addon2"
                >
                  <i class="fa fa-copy"></i> Copiar
                </button>
              </div>
            </div>
          </li>
        </ul>

        <div slot="footer" class="card-footer text-muted mb-2">
          Data da Solicitação: {{ formataDataUTC(item.createdAt) }}
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Button,
  Checkbox,
  Radio,
  FormGroupInput,
  Slider,
  Switch,
  Card,
  Tabs,
  TabPane,
  DropDown,
  Badge,
  Modal,
} from '@/components';

import { Popover, Tooltip, DatePicker } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/pt-br';
import locale2 from 'element-ui/lib/locale';
import VueQr from 'vue-qr';
import moment from 'moment';
import service from './../../services';
import locale from './../../locale';
import jwt from 'jsonwebtoken';
import swal from 'sweetalert';
import { Money } from 'v-money';
export default {
  components: {
    VueQr,
    [Badge.name]: Badge,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [FormGroupInput.name]: FormGroupInput,
    [Switch.name]: Switch,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    Slider,
    Card,
    Tabs,
    TabPane,
    DropDown,
    Modal,
    Money,
  },
  props: ['transacoes', 'financeiroTotal'],
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$',
        suffix: '',
        precision: 2,
      },
      refazCalculo: false,
      carregando: false,
      exibeEdit: false,
      dados: {},
      itemModal: {},
      decoded: {},
      interacoes: [],
      showModal: false,
      tipoModal: null,
      passo: null,
      form: {},
      namePasso: 'Todos',
      status: [
        { id: null, status: 'Todos' },
        { id: 1, status: 'Não Processado' },
        { id: 2, status: 'Em Processamento' },
        { id: 3, status: 'Em Aberto' },
        { id: 4, status: 'Processado com Falha' },
        { id: 5, status: 'Finalizado' },
        { id: 6, status: 'Cancelado' },
      ],
    };
  },
  methods: {
    buscaStatus(item) {
      this.$emit('atualiza', item.idRegistroFinanceiro);
    },
    copiarQR(qr) {
      //O texto que será copiado
      const texto = qr;
      //Cria um elemento input (pode ser um textarea)
      let inputTest = document.createElement('input');
      inputTest.value = texto;
      //Anexa o elemento ao body
      document.body.appendChild(inputTest);
      //seleciona todo o texto do elemento
      inputTest.select();
      //executa o comando copy
      //aqui é feito o ato de copiar para a area de trabalho com base na seleção
      document.execCommand('copy');
      //remove o elemento
      document.body.removeChild(inputTest);

      //swal('=)', 'QR Code foi copiado para a área de Transfêrencia', 'success')
      swal({
        title: '=)',
        text: 'QR Code foi copiado para a área de Transfêrencia',
        type: 'success',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 3000,
        closeOnConfirm: false,
      });
    },
    formataTitulo(tipoModal, itemModal) {
      if (tipoModal == 'Cancelar') {
        return this.calculaDataDiff(itemModal);
      } else return tipoModal;
    },
    verificaDataFim(item, data) {
      console.log(
        '-->',
        item.codConsulta,
        data,
        moment() > moment(data),
        moment() > data,
      );
      return moment() > moment(data.replace('Z', '')) ? true : false;
    },
    calculaDataDiff(item) {
      return moment() > moment(item.dataInicio.replace('Z', ''))
        ? 'Não Realizado'
        : 'Cancelar';
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (this.veeFields[ref]) {
        if (this.veeFields[ref].dirty) {
          if (this.veeFields[ref].valid == false) {
            return 'has-danger';
          } else {
            return 'has-success';
          }
        }
      }
      return null;
    },

    exibeModal(item, title) {
      this.itemModal = item;
      this.tipoModal = title;
      this.showModal = true;
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataDataUTC(data) {
      return moment(data)
        .utc()
        .format('DD/MM/YYYY HH:mm:ss');
    },
    selecionaStatus(item) {
      this.passo = item.id;
      this.namePasso = item.status;
    },
    transacoesFiltrados() {
      var arr = [];
      if (this.passo == null) arr = this.transacoes;
      else arr = this.transacoes.filter(x => x.idStatus == this.passo);
      return arr;
    },
  },
  mounted() {
    locale2.use(lang);
    this.$validator.localize('ptBr', locale);
  },
};
</script>

<style scoped>
select {
  padding: 10px !important;
}
input[type='radio'],
input[type='checkbox'] {
  margin-right: 10px !important;
}
.btnbuscar {
  font-size: 24px;
  text-transform: uppercase;
  color: #094049;
}
.corStatus1 {
  background-color: chocolate;
  border-color: chocolate;
}
.corStatus2 {
  background-color: #17a2b7;
  border-color: #17a2b7;
}
.corStatus3 {
  background-color: #ffb236;
  border-color: #ffb236;
}
.corStatus5 {
  background-color: #18ce0f;
  border-color: #18ce0f;
}
.corStatus4 {
  background-color: red;
  border-color: red;
}
.corStatus6 {
  background-color: #007bff;
  border-color: #007bff;
}

.input-group-text {
  height: 44px;
  padding-right: 10px;
  background-color: #000;
  color: #fff;
}

.input-group > .input-group-append > .btn {
  margin: 0px;
}
</style>
<style lang="scss">
.card-item {
  margin-bottom: 8px;
  .card-body {
    padding: 2px !important;
    .card-title {
      margin-top: 10px;
    }
  }
}
</style>
